import React from 'react'
import { FormattedMessage } from 'react-intl'

import { UNIT_TYPES } from 'constants'

export const TITLES = {
    [UNIT_TYPES.SORTIE]: (
        <FormattedMessage
            id='battles_schedule.sortie.title'
            defaultMessage='Периоды вылазок'
        />
    ),
    [UNIT_TYPES.FORT_BATTLE]: (
        <FormattedMessage
            id='battles_schedule.fort_battle.title'
            defaultMessage='Начало Наступлений'
        />
    ),
}



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Schedule/constants.jsx